const actions = {
  CLAIM_REPORT_LIST_BEGIN: 'CLAIM_REPORT_LIST_BEGIN',
  CLAIM_REPORT_LIST_SUCCESS: 'CLAIM_REPORT_LIST_SUCCESS',
  CLAIM_REPORT_LIST_ERR: 'CLAIM_REPORT_LIST_ERR',

  EXPORT_CLAIM_REPORT_LIST_BEGIN: 'EXPORT_CLAIM_REPORT_LIST_BEGIN',
  EXPORT_CLAIM_REPORT_LIST_SUCCESS: 'EXPORT_CLAIM_REPORT_LIST_SUCCESS',
  EXPORT_CLAIM_REPORT_LIST_ERR: 'EXPORT_CLAIM_REPORT_LIST_ERR',

  UPDATE_CLAIM_STATUS_BEGIN : 'UPDATE_CLAIM_STATUS_BEGIN',
  UPDATE_CLAIM_STATUS_SUCCESS : 'UPDATE_CLAIM_STATUS_SUCCESS',
  UPDATE_CLAIM_STATUS_ERR : 'UPDATE_CLAIM_STATUS_ERR',

  claimReportListingBegin: () => {
    return {
      type: actions.CLAIM_REPORT_LIST_BEGIN,
    };
  },
  claimReportListingSuccess: (data) => {
    return {
      type: actions.CLAIM_REPORT_LIST_SUCCESS,
      data,
    };
  },
  claimReportListingErr: (err) => {
    return {
      type: actions.CLAIM_REPORT_LIST_ERR,
      err,
    };
  },

  exportClaimReportListingBegin: () => {
    return {
      type: actions.EXPORT_CLAIM_REPORT_LIST_BEGIN,
    };
  },
  exportClaimReportListingSuccess: (data) => {
    return {
      type: actions.EXPORT_CLAIM_REPORT_LIST_SUCCESS,
      data,
    };
  },
  exportClaimReportListingErr: (err) => {
    return {
      type: actions.EXPORT_CLAIM_REPORT_LIST_ERR,
      err,
    };
  },
  //claim update states by kishan
    updateClaimStatusBegin: () => {
    return {
      type: actions.UPDATE_CLAIM_STATUS_BEGIN,
    };
  },
   updateClaimStatusSuccess: (data) => {
    return {
      type: actions.UPDATE_CLAIM_STATUS_SUCCESS,
      data
    };
  },

  updateClaimStatusErr: (error) => {
    return {
      type: actions.UPDATE_CLAIM_STATUS_ERR,
      error 
    };
  },
  
};
export default actions;
